export default "/images/06eefb7511062df88f284a684454a7eb.avif";